const dataSheetStyles = {
  cellLabel: {
    fontWeight: 500,
  },
};

export default dataSheetStyles;
